import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrdenesModel } from '../../models/ordenes_entrega/ordenes.model';

@Injectable({
  providedIn: 'root'
})
export class OrdenesService {

  private url = this.configService.config.servidor?.api_cart;
  private baseUrl = this.configService.config.servidor?.api_server;
  private accessToken: string = this.authService.usuario.token;
  
  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) { }

  getOrdenes(parametros:Object){
    // const url = `${this.baseUrl}/OrdenEntrega`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ORDEN_ENTREGA.VERSION + this.configService.resource.ORDEN_ENTREGA.PATH_BASE;
    let params = {};
    {Object.assign(params, parametros);}
    return this.http.get<OrdenesModel>(url, {params: params});
  }

  anularOrdenes(idOrden:number, motivo:string){
    let body = {};
    {Object.assign(body, {ObservacionEstado: motivo});}
    // const url = `${this.baseUrl}/OrdenEntrega/${idOrden}/Anulacion`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ORDEN_ENTREGA.ANULAR_ORDEN.VERSION + this.configService.resource.ORDEN_ENTREGA.PATH_BASE + this.configService.resource.ORDEN_ENTREGA.ANULAR_ORDEN.PATH_REL.replace('{id_orden}', idOrden);
    return this.http.put<any>(url, body);  
  }
  getOrdenId(id:number){
    // const url = `${this.baseUrl}/OrdenEntrega/${id}`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ORDEN_ENTREGA.GET_ORDEN.VERSION + this.configService.resource.ORDEN_ENTREGA.PATH_BASE + this.configService.resource.ORDEN_ENTREGA.GET_ORDEN.PATH_REL.replace('{id_orden}', id);
    let params = {};
    {Object.assign(params);}
    //{Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    // console.log(params);
    return this.http.get<[OrdenesModel]>(url, {params: params});
  }

  crearOrdenes(body:Object){
    // const url = `${this.baseUrl}/OrdenEntrega`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ORDEN_ENTREGA.VERSION + this.configService.resource.ORDEN_ENTREGA.PATH_BASE;
    return this.http.post<OrdenesModel>(url,  body);
  }

}
